import { observer } from "mobx-react-lite"
import React, { useContext, useEffect, useState } from 'react'
import { toastError, toastSuccess } from "../../FormComponents/Toasts"
import { FolderSchema } from "../../../schemas/FolderSchema"
import Modal from "../../Modal/Modal"
import { Formik, Form} from 'formik'
import Input from "../../FormComponents/Input"
import ReactSelect from "../../FormComponents/ReactSelect"
import axiosService from "../../../utils/AxiosService"
import { useNavigate, useParams } from "react-router-dom"
import { BrowseContext } from "../../../contexts/BrowseContext"

export default observer(function NewEditFolderModal() {
  const { client_id } = useParams()
  const { browseState, clients, folders, selectedFolder, openCreateFolder, openEditFolder } = useContext(BrowseContext)
  const clientOptions = clients.map(client => ({label: client.name, value: client.id}))
  const navigate =useNavigate()
  console.log(selectedFolder.name)

  const handleCreate = (folder) => {
    axiosService.post('/api/project_manager/folders', { folder })
    .then((newFolder) => {
      browseState.folders.push(newFolder)
      browseState.adjustClientFolderCount(newFolder.client_id, 1)
      browseState.toggleCreateFolder()
      navigate(`/project_manager/campaigns/clients/${newFolder.client_id}/folders/${newFolder.id}`)
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  const handleUpdate = (folder) => {
    axiosService.patch(`/api/project_manager/folders/${selectedFolder.id}`, { folder })
    .then((updatedFolder) => {
      if (+updatedFolder.client_id !== +selectedFolder.client_id) {
        browseState.adjustClientFolderCount(selectedFolder.client_id, -1)
        browseState.adjustClientFolderCount(updatedFolder.client_id, 1)
      }
      browseState.selectedFolder = {}
      browseState.toggleEditFolder()
      browseState.folders = folders.map(folder => folder.id === updatedFolder.id ? updatedFolder : folder)
      toastSuccess(`Folder ${updatedFolder.name} has been updated!`)
    })
  }

  return (
    <Modal isOpen={openCreateFolder || openEditFolder} onClose={() => openCreateFolder ? browseState.toggleCreateFolder() : browseState.toggleEditFolder() }>
      <Modal.Header>
        <h2 className='text-lg font-bold'>{ openCreateFolder ? 'Create Folder' : 'Edit Folder'}</h2>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            name: selectedFolder.name || '',
            client_id: selectedFolder.client_id || +client_id || ''
          }}
          enableReinitialize
          validationSchema={FolderSchema}
          onSubmit={openCreateFolder ? handleCreate : handleUpdate }
        >
          {({ setFieldValue, handleBlur, handleChange, values, touched, errors }) => (
            <Form className='w-[500px] -mt-10'>
              <Input
                error={touched.name && errors.name}
                noLabelPadding
                label="Name"
                placeholder="Folder name"
                name="name"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.name}
                className="px-3"
              />
              <div className="mt-3 mx-auto w-full">
                <ReactSelect
                  error={touched.client_id && errors.client_id}
                  noLabelPadding
                  label="Client"
                  name='client_id'
                  options={clientOptions}
                  disabled={openEditFolder}
                  value={values.client_id}
                  onChange={(client_id) => setFieldValue('client_id', client_id.value, true)}
                  onBlur={handleBlur}
                />
              </div>

              <div className="flex justify-between mt-5">
                <button
                  type='button'
                  className='rb-btn-cancel font-bold text-md ml p-2 px-4 rounded-lg'
                  onClick={() => openCreateFolder ? browseState.toggleCreateFolder() : browseState.toggleEditFolder()}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="ml-auto bg-rb-green text-white rounded-lg p-2 px-4 submit text-center active:shadow-outer active:shadow-rb-green border-rb-green"
                >
                  {openCreateFolder ? 'Create' : 'Update' }
                </button>
              </div>
            </Form>
           )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
})
